import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import type { Theme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useState } from 'react';
import { INDUSTRY_TRACKER_IMAGES } from '@/pages/LandingPage/constants';
import type { IndustryTracker, IndustryTrackerTypeEnum } from '@/types/GraphqlSchema';
import { Tracker } from './Tracker';

const useStyles = makeStyles((theme: Theme) => ({
  details: {
    padding: 0,
  },
  label: {
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontSize: '10px',
    },
    fontWeight: 'bold',
  },
  summary: {
    '& > .MuiAccordionSummary-content': {
      alignItems: 'center',
    },
  },
}));

type IndustryTrackerProps = {
  industryTracker: IndustryTracker;
  onClick: (type: IndustryTrackerTypeEnum, region: string, subType: string) => void;
};

export const IndustryTrackerList = ({ industryTracker, onClick }: IndustryTrackerProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const { name, type, regions, userEntitledRegions } = industryTracker;
  const image = INDUSTRY_TRACKER_IMAGES[type];

  return (
    <Accordion square={true} expanded={expanded} onChange={(_, exp) => setExpanded(exp)}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel-layers'
      >
        <img src={image} width='20px' height='20px' alt={`${name}-icon`} />
        &nbsp;&nbsp;
        <Typography className={classes.label} variant='caption'>
          {name}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {regions.map(({ displayName, region, type: subType }) => (
          <Tracker
            key={displayName}
            title={displayName || ''}
            onClick={() => onClick(type, region || '', subType || '')}
            enabled={userEntitledRegions?.includes(displayName || '') ?? false}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
